import { ServiceData } from '@/types';

import articles from './COOKING_ARTICLES_LT.json';
import recipes from './COOKING_RECIPES_LT.json';
import videos from './COOKING_VIDEOS_LT.json';

export const COOKING_DATA_LT: ServiceData = {
  articles,
  recipes,
  videos,
};
